import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Menu`

export function buscarTodos() {
  return http.get(`${API_ENDPOINT}/BuscarTodos`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los menús.',
      tipoError: 'menu'
    }
  })
}
